import React from 'react';
import useStyle from './badgeRanking.style';
import Lots from '../../../atoms/Images/Lots';
import { classNames } from '../../../../helpers/style/classNames';
import { ImagesLots } from '../../../../types/Lots';

export interface BadgeRankingProps {
  note: number;
  position: number | (1 | 2 | 3);
  lot?: ImagesLots;
}

export const BadgeRanking = ({ note, position, lot }: BadgeRankingProps) => {
  const classes = useStyle();
  let variant: string;

  if (position === 1) variant = 'gold';
  if (position === 2) variant = 'silver';
  if (position === 3) variant = 'bronze';

  return (
    <div
      className={classNames(
        [classes.root, classes[variant]],
        [
          {
            condition: lot === null,
            classe: classes.noLots
          },
          {
            condition: lot !== null,
            classe: classes.lots
          }
        ]
      )}
    >
      <div className={classes.line1}>
        <span className={classes.position}>
          {position}
          {position === 1 ? 'ère' : 'ème'} place
        </span>
        {lot && <img className={classes.img} src={Lots[lot]} alt={lot} />}
      </div>
      <p className={classes.note}>{note} / 20</p>
    </div>
  );
};
